import { render, staticRenderFns } from "./FooterLiveCheckContainer.vue?vue&type=template&id=cdf2882c&scoped=true&"
import script from "./FooterLiveCheckContainer.vue?vue&type=script&lang=ts&"
export * from "./FooterLiveCheckContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf2882c",
  null
  
)

export default component.exports